import { getUms, makeRequest, postUms } from './baseService';

const getHeaders = (email, password) => {
  const encodedCreds = btoa(`${email}:${password}`);
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Basic ${encodedCreds}`,
    'X-Procurement': true,
    Source: 'ProcureLive',
    type: 'jwt',
    IdentityProvider: 'password',
  };
};

export const getUserInfoFromTokenAPI = (token) => {
  const request = {
    url: 'user-onboarding/onboarding-token-status',
    data: {
      requestToken: token,
    },
  };
  return postUms(request);
};

export const signupAPI = (data, token) => {
  const url = 'user-onboarding/signup';
  const options = {
    method: 'POST',
    headers: getHeaders(data.email, data.password),
    mode: 'cors',
    body: JSON.stringify({ requestToken: token }),
  };
  return makeRequest({ url, options, umsRequest: true })
    .then((response) => response)
    .catch((err) => {
      console.log(err);
    });
};
